import type { FranchiseRegion } from '../types'

export const FRANCHISE_REGIONS: FranchiseRegion[] = [
  { value: 'HQ', label: 'HQ (Corporate)' },
  { value: 'north_york', label: 'North York' },
  { value: 'london', label: 'London' },
  { value: 'toronto', label: 'Toronto' },
  { value: 'hamilton', label: 'Hamilton' },
  { value: 'mississauga', label: 'Mississauga' },
  { value: 'brampton', label: 'Brampton' },
  { value: 'scarborough', label: 'Scarborough' }
]
